import React, { useEffect, useMemo } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { listPortfolio } from "../../actions/portfolioActions";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import Meta from "../../components/Meta";
import PortfolioMagazine from "../../components/portfolio/PortfolioMagazine";
import { JEWELRY_HIRE_CATALOG_KEY } from "../../constants/shopMeta";

import "./JewelryHire.css";

const DEFAULT_DESCRIPTION =
  "Explore Academy Costumes London's jewellery collection, available for private hire by direct enquiry.";
const DEFAULT_IMAGE = "/images/home/jewellery-rental.jpg";

const getFirstPortfolioImage = (items = []) => {
  for (const item of items) {
    const image = Array.isArray(item?.images)
      ? item.images.find((candidate) => candidate?.url)
      : null;

    if (image?.url) return image;
  }

  return null;
};

export default function JewelryHireScreen() {
  const dispatch = useDispatch();
  const { loading, error, items = [] } = useSelector(
    (state) => state.portfolioList || {},
  );

  useEffect(() => {
    dispatch(listPortfolio(JEWELRY_HIRE_CATALOG_KEY));
  }, [dispatch]);

  const heroImage = useMemo(() => getFirstPortfolioImage(items), [items]);
  const firstItem = items[0] || {};
  const metaDescription =
    firstItem.subtitle ||
    firstItem.caption ||
    (Array.isArray(firstItem.body) ? firstItem.body[0] : "") ||
    DEFAULT_DESCRIPTION;

  return (
    <>
      <Meta
        title="Jewellery Hire | Academy Costumes London"
        description={metaDescription}
        image={heroImage?.url || DEFAULT_IMAGE}
        url="/jewelry-hire"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Jewellery Hire", url: "/jewelry-hire" },
        ]}
      />

      <Container as="main" fluid className="p-0 jewelry-hire-page">
        {loading ? (
          <div className="jewelry-showcase-status">
            <Loader />
          </div>
        ) : error ? (
          <div className="jewelry-showcase-status">
            <Message variant="danger">{error}</Message>
          </div>
        ) : items.length > 0 ? (
          <PortfolioMagazine items={items} />
        ) : (
          <div className="jewelry-showcase-status">
            <Message>No jewellery hire slides yet.</Message>
          </div>
        )}
      </Container>
    </>
  );
}
